import { UserInfoModel } from './user-info-model';

export var userInfo = new UserInfoModel({ id: 'userInfo' });
export { UserInfoView } from './user-info-view';
